import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { convertBytes } from '@jove-frontend/uikit';
import { FolderOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import { useDropzone } from 'react-dropzone';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveFileDragUploadFilesView = function JoveFileDragUploadFilesView(props) {
  var className = props.className,
      _props$maxFiles = props.maxFiles,
      maxFiles = _props$maxFiles === void 0 ? 1 : _props$maxFiles,
      selectFiles = props.selectFiles,
      _props$descList = props.descList,
      descList = _props$descList === void 0 ? ['Drag & drop or click here to upload files'] : _props$descList,
      emitError = props.emitError,
      imgSlot = props.imgSlot,
      _props$fileAccept = props.fileAccept,
      fileAccept = _props$fileAccept === void 0 ? 'application/pdf' : _props$fileAccept;

  var _useDropzone = useDropzone({
    accept: fileAccept,
    onDrop: function onDrop(acceptedFiles) {
      if ((acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) > maxFiles) {
        emitError === null || emitError === void 0 ? void 0 : emitError({
          msg: "You can only upload ".concat(maxFiles, " files")
        });
      } else {
        selectFiles === null || selectFiles === void 0 ? void 0 : selectFiles(acceptedFiles.map(function (item) {
          var sizeInfo = convertBytes(item.size, {
            fixLength: 2
          });
          return {
            id: uniqueId(),
            sizeText: "".concat(sizeInfo === null || sizeInfo === void 0 ? void 0 : sizeInfo.MB, " MB"),
            file: item
          };
        }));
      }
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      open = _useDropzone.open;

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({}, getRootProps({
    className: 'dropzone'
  })), {}, {
    onClick: open,
    className: clsx('border-grey-20 rounded-xl border-2 border-dashed text-center', className),
    children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center space-y-2",
      children: [!!imgSlot ? imgSlot : /*#__PURE__*/_jsx(FolderOutlined, {
        className: "h-12 w-12"
      }), (descList === null || descList === void 0 ? void 0 : descList.length) > 0 && /*#__PURE__*/_jsx(Box, {
        className: "flex flex-col space-y-1",
        children: descList.map(function (text) {
          return /*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            className: "font-medium",
            children: text
          });
        })
      })]
    })]
  }));
};

export default JoveFileDragUploadFilesView;